import React from "react";

type Props = React.HTMLAttributes<HTMLSpanElement>;

export function Badge({ className = "", children, ...props }: Props) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}

export default Badge;
